import { render, staticRenderFns } from "./ToolsBrowser.vue?vue&type=template&id=2aea4de2&scoped=true&"
import script from "./ToolsBrowser.vue?vue&type=script&lang=js&"
export * from "./ToolsBrowser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aea4de2",
  null
  
)

export default component.exports